import { render, staticRenderFns } from "./Viewcomments.vue?vue&type=template&id=57231c37&"
import script from "./Viewcomments.vue?vue&type=script&lang=js&"
export * from "./Viewcomments.vue?vue&type=script&lang=js&"
import style0 from "./Viewcomments.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports